/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TapeLibrarySlot,
    TapeLibrarySlotFromJSON,
    TapeLibrarySlotFromJSONTyped,
    TapeLibrarySlotToJSON,
} from './';

/**
 * 
 * @export
 * @interface TapeLibraryEndpointResponse
 */
export interface TapeLibraryEndpointResponse {
    /**
     * 
     * @type {Array<TapeLibrarySlot>}
     * @memberof TapeLibraryEndpointResponse
     */
    drives: Array<TapeLibrarySlot>;
    /**
     * 
     * @type {Array<TapeLibrarySlot>}
     * @memberof TapeLibraryEndpointResponse
     */
    mailbox: Array<TapeLibrarySlot>;
    /**
     * 
     * @type {Array<TapeLibrarySlot>}
     * @memberof TapeLibraryEndpointResponse
     */
    slots: Array<TapeLibrarySlot>;
}

export function TapeLibraryEndpointResponseFromJSON(json: any): TapeLibraryEndpointResponse {
    return TapeLibraryEndpointResponseFromJSONTyped(json, false);
}

export function TapeLibraryEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeLibraryEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'drives': ((json['drives'] as Array<any>).map(TapeLibrarySlotFromJSON)),
        'mailbox': ((json['mailbox'] as Array<any>).map(TapeLibrarySlotFromJSON)),
        'slots': ((json['slots'] as Array<any>).map(TapeLibrarySlotFromJSON)),
    };
}

export function TapeLibraryEndpointResponseToJSON(value?: TapeLibraryEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'drives': ((value.drives as Array<any>).map(TapeLibrarySlotToJSON)),
        'mailbox': ((value.mailbox as Array<any>).map(TapeLibrarySlotToJSON)),
        'slots': ((value.slots as Array<any>).map(TapeLibrarySlotToJSON)),
    };
}


